import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Sessions live in HttpOnly cookies set by the backend; nothing is stored in JS-readable storage.
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "TotalTickets" } });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/")) {
      if (!window.location.pathname.startsWith("/login")) {
        const reason = err.response?.data?.detail;
        if (typeof reason === "string") sessionStorage.setItem("tt_logout_reason", reason);
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fileUrl = (id, download = false) => `${API}/files/${id}${download ? "?download=true" : ""}`;
